<app-loader *ngIf="loading"></app-loader>

<div *ngIf="!loading && navigationItems && navigationItems.length > 0">
  <!-- Added by amisha on 24/12/2025 for email toggle switch -->
  @if (!templateForPermitForm) {
  <div class="switch pl-5 pt-2" *ngIf="hasEmailsToDisplay">
    <label>
      <input
        type="checkbox"
        [(ngModel)]="showEmails"
        (change)="setCurrentNavigationItems()"
      />
      Show emails
    </label>
  </div>

  } @else {
  <div class="pl-5 pt-2" *ngIf="hasEmailsToDisplay">
    <label class="email-toggle">
      <input
        type="checkbox"
        [(ngModel)]="showEmails"
        (change)="setCurrentNavigationItems()"
      />

      <span class="toggle-slider"></span>

      <wm-common-text
        class="email-toggle-text"
        [data]="{ text: 'Show emails' }"
      ></wm-common-text>
    </label>
  </div>
  }
  <!-- Ended by amisha on 24/12/2025 for email toggle switch -->

  <ul
    [ngClass]="{
      'template-form': templateForPermitForm,
      'list-group': !templateForPermitForm
    }"
    *ngIf="!templateForPermitForm; else templateStep"
  >
    <li
      *ngFor="let ni of currentNavigationItems; index as i"
      [ngbTooltip]="getTooltip(ni)"
      container="body"
    >
      <a
        class="list-group-item list-group-item-action activity-item"
        [ngClass]="{ 'active-activity': isActive(ni) }"
        (click)="navigate(ni)"
      >
        <div class="d-flex w-100">
          <div class="activity-circle" [ngClass]="navClass(ni)">
            {{ i + 1 }}
            <div class="vl" *ngIf="!ni.isEnd">&nbsp;</div>
          </div>

          <div
            class="align-self-center"
            [ngStyle]="{
              'text-decoration': !ni.activityRole ? 'none' : 'underline'
            }"
            [ngClass]="{ 'font-weight-bold': !ni.completed }"
          >
            {{ ni.activityLabel }}
          </div>
        </div>
      </a>
    </li>
    <li
      *ngIf="!currentNavigationItems[currentNavigationItems.length - 1].isEnd"
    >
      <a class="list-group-item list-group-item-action activity-item">
        <div class="activity-circle">
          {{ currentNavigationItems.length + 1 }}
        </div>
        Next Steps...
      </a>
    </li>
  </ul>
  <!-- added by priya 2025-11-04 -->
  <ng-template #templateStep>
    <div class="wizard-steps" #wizardSteps>
      <div
        *ngFor="let ni of currentNavigationItems; index as i"
        class="step"
        [ngClass]="getStepStatus(ni, i)"
(click)="onStepClick(ni)"
        #stepElem
      >
        <div class="step-icon">
          <!-- only show check icon when completed, otherwise empty circle -->
          <ng-container *ngIf="getStepStatus(ni, i) === 'completed'">
            <mat-icon class="check-icon">check</mat-icon>
          </ng-container>
        </div>

        <!-- <common-typography

            class="step-label"
            [text]="ni.activityLabel"
          ></common-typography> -->
        <div
          class="step-label"
          [ngClass]="{
            'active-step': getStepStatus(ni, i) === 'active',
            'completed-step': getStepStatus(ni, i) === 'completed',
            'inactive-step': getStepStatus(ni, i) === 'upcoming'
          }"
        >
          <wm-common-text [data]="{ text: ni.activityLabel }"></wm-common-text>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- end by priya 2025-11-04 -->
</div>
